var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9562 72.8607C57.4486 72.8607 73.2503 57.059 73.2503 37.5666C73.2503 18.0742 57.4486 2.27246 37.9562 2.27246C18.4638 2.27246 2.66211 18.0742 2.66211 37.5666C2.66211 57.059 18.4638 72.8607 37.9562 72.8607Z",
    fill: "#A7B7DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8892 18.8607C61.6465 28.8203 50.573 35.4379 37.9553 35.4379C25.3377 35.4379 14.2642 28.8203 8.02148 18.8607C14.2531 8.90115 25.3377 2.27246 37.9553 2.27246C50.573 2.27246 61.6575 8.90115 67.8892 18.8607Z",
    fill: "#A7B7DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2878 27.4766V60.0302H23.1289C21.7449 60.0302 20.623 58.9083 20.623 57.5244V27.4766H55.2878Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.623 27.4772L25.3887 24.2471V27.4772H20.623Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4727 26.9008V21.2671L25.3881 24.2469L21.4727 26.9008Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2871 27.4772L50.5215 24.2471V27.4772H55.2871Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4369 26.9008V21.2671L50.5215 24.2469L54.4369 26.9008Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4386 21.2686L50.5224 24.2478V27.477H25.3888V24.2478L21.4727 21.2686H54.4386Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0678 33.1221C47.0678 33.7665 46.669 34.3085 46.1167 34.5233C45.9428 34.5949 45.7588 34.6358 45.5644 34.6358C45.3701 34.6358 45.1758 34.5949 45.0019 34.5233C44.4394 34.3085 44.0508 33.7665 44.0508 33.1221C44.0508 32.4778 44.4394 31.9357 45.0019 31.721C45.1758 31.6493 45.3701 31.6084 45.5644 31.6084C45.7588 31.6084 45.9428 31.6493 46.1167 31.721C46.669 31.9357 47.0678 32.4778 47.0678 33.1221Z",
    fill: "#FF3445"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8589 33.1221C31.8589 33.7665 31.4601 34.3085 30.9078 34.5233C30.7339 34.5949 30.5498 34.6358 30.3555 34.6358C30.1612 34.6358 29.9669 34.5949 29.793 34.5233C29.2304 34.3085 28.8418 33.7665 28.8418 33.1221C28.8418 32.4778 29.2304 31.9357 29.793 31.721C29.9669 31.6493 30.1612 31.6084 30.3555 31.6084C30.5498 31.6084 30.7339 31.6493 30.9078 31.721C31.4601 31.9357 31.8589 32.4778 31.8589 33.1221Z",
    fill: "#FF3445"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.116 31.721V40.7212C46.116 45.2315 42.4546 48.8929 37.9545 48.8929C33.4544 48.8929 29.793 45.2315 29.793 40.7212V31.721C29.9668 31.6493 30.1611 31.6084 30.3555 31.6084C30.5498 31.6084 30.7339 31.6493 30.9077 31.721V40.7212C30.9077 44.6076 34.0681 47.7679 37.9545 47.7679C41.841 47.7679 45.0013 44.6076 45.0013 40.7212V31.721C45.1751 31.6493 45.3695 31.6084 45.5638 31.6084C45.7581 31.6084 45.9422 31.6493 46.116 31.721Z",
    fill: "#FF3445"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0178 63.4298C56.0178 64.1072 47.9303 64.6567 37.9572 64.6567C27.984 64.6567 19.8965 64.1072 19.8965 63.4298C19.8965 62.7524 27.984 62.2104 37.9572 62.2104C47.9303 62.2104 56.0178 62.7524 56.0178 63.4298Z",
    fill: "black"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6013 53.7204C61.6013 57.2056 58.7778 60.0291 55.2926 60.0291C51.7962 60.0291 48.9727 57.2056 48.9727 53.7204C48.9727 50.2349 51.7962 47.4004 55.2926 47.4004C58.7778 47.4004 61.6013 50.2349 61.6013 53.7204Z",
    fill: "#FF3445"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9179 56.345C57.5869 56.687 57.0245 56.687 56.6826 56.345L55.2818 54.9442L53.8811 56.345C53.5392 56.687 52.9987 56.687 52.6568 56.345C52.3149 56.0032 52.3149 55.4517 52.6568 55.1097L54.0465 53.7091L52.6568 52.3194C52.3149 51.9774 52.3149 51.4149 52.6568 51.084C52.9987 50.7421 53.5502 50.7531 53.8921 51.095L55.2818 52.4847L56.6826 51.084C57.0245 50.7421 57.5869 50.7421 57.9179 51.0729C58.2598 51.4149 58.2487 51.9774 57.9068 52.3194L56.5171 53.7091L57.9179 55.1208C58.2598 55.4626 58.2598 56.0032 57.9179 56.345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.313512f5e9d9159181879084930359af.svg";
export { ForwardRef as ReactComponent };